import React from 'react'
import { withTheme } from 'styled-components'
import { transparentize } from 'polished'
import Switch from 'react-switch'

export default withTheme(props => (
  <Switch
    {...props}
    checkedIcon={false}
    uncheckedIcon={false}
    activeBoxShadow={`0 0 2px 4px ${transparentize(
      0.8,
      props.theme.colors.interactive
    )}`}
    handleDiameter={20}
    height={24}
    width={48}
  />
))
